// CSRF token management for React frontend
let csrfToken = null;
let tokenPromise = null;

// Get CSRF token from server
const getCSRFToken = async (forceRefresh = false) => {
  // If forcing refresh or no token exists, get a new one
  if (forceRefresh || !csrfToken) {
    if (tokenPromise && !forceRefresh) {
      return tokenPromise;
    }

    tokenPromise = fetch('/api/csrf-token', {
      method: 'GET',
      credentials: 'include', // Include cookies for session
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to get CSRF token');
        }
        return response.json();
      })
      .then(data => {
        csrfToken = data.csrfToken;
        tokenPromise = null; // Clear promise after success
        return csrfToken;
      })
      .catch(error => {
        console.error('Error fetching CSRF token:', error);
        tokenPromise = null; // Reset promise on error
        csrfToken = null; // Clear cached token on error
        throw error;
      });

    return tokenPromise;
  }

  // Return cached token
  return csrfToken;
};

// Clear CSRF token (useful for logout)
const clearCSRFToken = () => {
  csrfToken = null;
  tokenPromise = null;
};

// Enhanced fetch with CSRF token
const fetchWithCSRF = async (url, options = {}) => {
  const token = await getCSRFToken();
  
  const enhancedOptions = {
    ...options,
    credentials: 'include', // Include cookies for session
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': token,
      ...options.headers,
    },
  };

  return fetch(url, enhancedOptions);
};

// Enhanced authenticated fetch with CSRF token
const authenticatedFetchWithCSRF = async (url, options = {}) => {
  const token = await getCSRFToken();
  
  // Get auth token from localStorage
  const authToken = localStorage.getItem('authToken');
  if (!authToken) {
    throw new Error('No authentication token found');
  }

  const enhancedOptions = {
    ...options,
    credentials: 'include', // Include cookies for session
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
      'X-CSRF-Token': token,
      ...options.headers,
    },
  };

  return fetch(url, enhancedOptions);
};

export {
  getCSRFToken,
  clearCSRFToken,
  fetchWithCSRF,
  authenticatedFetchWithCSRF
};
